import styled from 'styled-components';

export const NodeBodyContainer = styled.div`
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.text.subtext};

  font-size: 10px;
  padding: 0.75rem 1rem;
  border-radius: 7px 7px 0 0;
  font-family: 'Inter';

  border-bottom: 1px solid ${({ theme }) => theme.line.node};
  white-space: pre-wrap;
`;
